export default { 
  hd183dc06cf5d4b73bab99d15aa222ce6: [[({}, [C0, C1]) => [C0(), C1()], {}]] 
}